import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { searchPage } from '@backstage/plugin-search/alpha';
import { SearchPage } from '../../components/search/SearchPage';

// PAT-1023: `/search` is served by `@backstage/plugin-search/alpha`. This
// override keeps the extension id `page:search`, its path, route ref (used by
// the sidebar modal's "View Full Results"), config and inputs, and only swaps
// the page for our custom one. The framework header is off: the page renders
// its own `Header`.
export const searchModule = createFrontendModule({
  pluginId: 'search',
  extensions: [
    searchPage.override({
      params: { noHeader: true, loader: async () => <SearchPage /> },
    }),
  ],
});
